import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {PERIOD_CONTROL_MEDICATION_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/period-control-medication/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/period-control-medication/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/period-control-medication/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/period-control-medication/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/period-control-medication/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/period-control-medication/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/period-control-medication/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/period-control-medication/Questionnaire8Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const PeriodControlMedication = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case PERIOD_CONTROL_MEDICATION_KEYS.START:
        trackPageViewGA('/period-control-med/start', 'MDQ-Period Control Med - Start');
        return <Questionnaire1Screen />;
      case PERIOD_CONTROL_MEDICATION_KEYS.PROFILE:
        trackPageViewGA('/period-control-med/profile', 'MDQ-Period Control Med - Profile');
        return <Questionnaire2Screen />;
      case PERIOD_CONTROL_MEDICATION_KEYS.INVALID:
        trackPageViewGA('/period-control-med/invalid', 'MDQ-Period Control Med - Invalid');
        return <Questionnaire3Screen />;
      case PERIOD_CONTROL_MEDICATION_KEYS.MEDICAL_HISTORY:
        trackPageViewGA('/period-control-med/medical-history', 'MDQ-Period Control Med - Medical History');
        return <Questionnaire4Screen />;
      case PERIOD_CONTROL_MEDICATION_KEYS.HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH:
        trackPageViewGA(
          '/period-control-med/had-blood-pressure-measured-last-6-month',
          'MDQ-Period Control Med - Had Blood Pressure Measured Last 6 Month',
        );
        return <Questionnaire5Screen />;
      case PERIOD_CONTROL_MEDICATION_KEYS.DO_SMOKE:
        trackPageViewGA('/period-control-med/do-smoke', 'MDQ-Period Control Med - Do Smoke');
        return <Questionnaire6Screen />;
      case PERIOD_CONTROL_MEDICATION_KEYS.OTHER_MEDICATIONS_OR_SUPPLEMENTS:
        trackPageViewGA(
          '/period-control-med/other-medications-or-supplements',
          'MDQ-Period Control Med - Other Medications Or Supplements',
        );
        return <Questionnaire7Screen />;
      case PERIOD_CONTROL_MEDICATION_KEYS.OTHER_MEDICAL_HISTORY:
        trackPageViewGA('/period-control-med/other-medical-history', 'MDQ-Period Control Med - Other Medical History');
        return <Questionnaire8Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <NotFoundPage />;
    }
  };

  return renderQuestion();
};

export default PeriodControlMedication;
